"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteMyGroupInvitationEndpoint = void 0;
const endpoint_1 = require("../../general/endpoint");
class DeleteMyGroupInvitationEndpoint extends endpoint_1.BaseDeleteEndpoint {
    constructor(request) {
        super();
        this.groupId = request.groupId;
    }
    getUrl() {
        return `/v2/me/groups/${this.groupId}/invitations`;
    }
}
exports.DeleteMyGroupInvitationEndpoint = DeleteMyGroupInvitationEndpoint;
